export default __webpack_public_path__ + "static/media/R7PG23.66ab50ee.png";